import { STATES, ITEM_KINDS, STEP_URLS } from '@mover-app/constants';
import { trackEngagement } from '@mover-app/engagement';

export const BASE_PATH = STEP_URLS.STEP_BACKUP_GENERATOR;
export function BackupGeneratorConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_BACKUP_GENERATOR, {
    url: `${BASE_PATH}`,
    disableBreadcrumb: true,
    title: 'Generator Installation',
    views: {
      '@': {
        template: `<div>
          <iframe style="width: 100%; display: block; max-width: 1180px; margin: 0 auto; border: none"></iframe>
        </div>`,
        controller: $element => {
          trackEngagement({
            code: ITEM_KINDS.BACKUP_GENERATOR,
            name: 'Backup Generator',
          });

          const iframe = $element.find('iframe')[0];

          const url = `https://partner.homeperks.com/include/home-advisor-pro-lookup/?proj=generator-installation`;

          iframe.src = `${url}&timestamp=${new Date().getTime()}`;

          window.addEventListener('message', function(event) {
            var dataFlowDir =
                event.data.hp_homeadvisor_pro_lookup_data_flow_dir,
              data = event.data.hp_homeadvisor_pro_lookup_data;

            if (!iframe || !dataFlowDir) return;

            switch (dataFlowDir) {
              case 'iframeToParent':
                if (data.iframeHeight) {
                  iframe.style.height = data.iframeHeight + 'px';
                }
                break;
              case 'parentToIframe':
                iframe.contentWindow.postMessage(
                  {
                    iframeTopOffset: iframe.offsetTop,
                    parentTopScroll: window.scrollY || document.body.scrollTop,
                  },
                  '*'
                );
                break;
            }
          });
        },
      },
    },
    scrollTop: true,
    analytics: {
      page: 'Backup Generator',
    },
    data: {
      permissions: 'signedIn',
      moveItem: {
        type: ITEM_KINDS.BACKUP_GENERATOR,
        singleton: true,
      },
    },
  });
}
